import { HeaderGroup } from "@tanstack/react-table";

type SkeletonHeaderRowProps<T> = {
  headerGroup: HeaderGroup<T>;
};

const width = 300;

const SkeletonHeaderRow = <T,>({ headerGroup }: SkeletonHeaderRowProps<T>) => {
  return (
    <tr className="animate-pulse" data-testid={"table-loading-header-row"}>
      {headerGroup.headers.map((header, index) => (
        <th
          key={index}
          style={{
            width: `${width}px`,
            minWidth: `${width}px`,
            maxWidth: `${width}px`,
          }}
          className="h-9 border-b border-r border-gray-300 bg-gray-100"
        />
      ))}
    </tr>
  );
};

export default SkeletonHeaderRow;
